import React, { Fragment } from "react";
import formItemLayout from "../../../const/form/formItemLayout";
import { Form, Input } from 'antd';

function Phones({ data, setData, handleInput }){
    return(
        <Fragment>
            <Form.Item 
                {...formItemLayout} 
                label="Telefone" 
            >
                <Input 
                    value={data.phone} 
                    placeholder="Digite o numero do telefone"
                    onChange={e => handleInput(e, "", data, setData)}
                    name="phone"
                    style={{ width: "80%"}}
                />
            </Form.Item>   
            <Form.Item 
                {...formItemLayout} 
                label="Celular" 
                hasFeedback
            >
                <Input 
                    value={data.celphone} 
                    placeholder="Digite o numero do celular"
                    onChange={e => handleInput(e, "", data, setData)}
                    name="celphone"
                    required={true}
                    style={{ width: "80%"}}
                />
            </Form.Item>
        </Fragment>
    )
}

export default Phones;


// WEBPACK FOOTER //
// ./src/components/common/form/Phones.jsx